import React, { useState } from 'react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from './ui/dialog';
import { Badge } from './ui/badge';
import { Info, ExternalLink } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

const ServiceTooltip = ({ service, children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Show tooltip if service has detailed description or regular description
  if (!service.detailedDescription && !service.description) {
    return children;
  }

  return (
    <TooltipProvider>
      <div className="flex items-center gap-2">
        {children}
        
        {/* Detailed Modal - Info Button */}
        <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
          <DialogTrigger asChild>
            <Button
              variant="outline"
              size="sm"
              className="h-7 px-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 border-blue-200"
            >
              <Info className="h-4 w-4 mr-1" />
              <span className="text-xs">Info</span>
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-2xl">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                {service.name}
                <Badge 
                  variant={service.type === 'monatlich' ? 'default' : 'secondary'}
                  className={service.type === 'monatlich' ? 'bg-orange-100 text-orange-800' : 'bg-green-100 text-green-800'}
                >
                  {service.type}
                </Badge>
              </DialogTitle>
            </DialogHeader>
            
            <div className="space-y-4">
              <div>
                <h4 className="font-semibold text-sm text-gray-700 mb-2">Kurzbeschreibung:</h4>
                <p className="text-gray-600">{service.description}</p>
              </div>
              
              <div>
                <h4 className="font-semibold text-sm text-gray-700 mb-2">Leistungsumfang:</h4>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <pre className="whitespace-pre-wrap text-sm text-gray-700 font-sans">
                    {service.detailedDescription}
                  </pre>
                </div>
              </div>
              
              <div className="flex justify-between items-center pt-4 border-t">
                <div>
                  <span className="text-lg font-bold text-blue-600">
                    {service.price.toLocaleString('de-DE')}€
                  </span>
                  <span className="text-sm text-gray-500 ml-1">
                    {service.type === 'monatlich' ? '/Monat' : 'einmalig'}
                  </span>
                </div>
                
                {service.notice && (
                  <div className="text-xs text-orange-600 bg-orange-50 px-2 py-1 rounded max-w-xs">
                    ⚠️ {service.notice}
                  </div>
                )}
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </TooltipProvider>
  );
};

export default ServiceTooltip;